import * as Yup from 'yup';

import { AssetsImage, AssociateImages } from '~models';
import { SelectOption } from '~ui-kit';

export const getAssetsImagesOptions = (images: AssetsImage[] = []): SelectOption[] => {
  if (!images) {
    return [];
  }

  return images.map(image => ({ value: image.id, label: image.assetName, optional: image.notes ? `Notes: ${image.notes}` : '' }));
};

export const getInitialValues = (images: AssociateImages): { imageIds: number[] } => {
  if (!images) {
    return { imageIds: [] as number[] };
  }

  const value = images.images.map(item => item.id) as number[];

  return { imageIds: value || [] as number[] };
};

export const validationSchema = Yup.object({
  imageIds: Yup.array().of(Yup.string()
    .test({
      message: 'Image Required',
      test(value) {
        return Boolean(value);
      },
    })
    .test({
      message: 'Duplicated Image',
      test(value) {
        const existing = this.parent.filter(v => v === value);
        return existing.length <= 1;
      },
    })
  ),
});
